const CustomReply = () =>
  import('@/views/main/wechatMgmt/customReply/CustomReply.vue')
export default {
  path: '/main/wechatMgmt/customReply',
  name: 'CustomReply',
  component: CustomReply
}
